import React from "react";

const TaskerEditProfileSkelton = () => {
  return (
    <div className="animate-pulse w-full flex flex-col gap-6">
      <div>
        <div className="flex flex-col gap-[1.875rem] ">
          {/* Section Heading */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
            <div className="h-6 bg-gray-400 rounded w-40"></div>
          </div>

          {/* Profile Image Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-20 h-20 rounded-full bg-gray-200"></div>
            <div className="h-6 bg-gray-200 rounded w-40"></div>
          </div>

          {/* Name Inputs */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.063rem]">
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-24"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-24"></div>
              <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
            </div>
          </div>
          

          {/* Additional Requirement Section */}
          <div className="flex flex-col gap-4">
            {/* Section Heading */}

            {/* Image Upload Area */}
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-20"></div>
              <div className="h-40 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                <div className="h-8 w-40 bg-gray-300 rounded"></div>
              </div>
              <div className="h-5 bg-gray-200 rounded w-20"></div>
              <div className="h-16 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-start">
                <div className="h-9 w-8 bg-gray-300 rounded ml-3"></div>
              </div>
              <div className="h-16 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-start">
                <div className="h-9 w-8 bg-gray-300 rounded ml-3"></div>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[1.063rem]">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
            ))}
          </div>

          {/* Additional Requirement Section */}
          <div className="flex flex-col gap-4">
            {/* Section Heading */}

            {/* Image Upload Area */}
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-20"></div>
              <div className="h-40 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center">
                <div className="h-8 w-40 bg-gray-300 rounded"></div>
              </div>
              <div className="h-5 bg-gray-200 rounded w-20"></div>
              <div className="h-16 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-start">
                <div className="h-9 w-8 bg-gray-300 rounded ml-3"></div>
              </div>
              <div className="h-16 bg-gray-200 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-start">
                <div className="h-9 w-8 bg-gray-300 rounded ml-3"></div>
              </div>
            </div>
          </div>

          {/* About Me Input */}
          <div className="flex flex-col gap-2">
            <div className="h-5 bg-gray-200 rounded w-32"></div>
            <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
          </div>

          {/* Professional Details Heading Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
            <div className="h-6 bg-gray-400 rounded w-40"></div>
          </div>

          {/* Professional Details Section Heading Skeleton */}
          <div className="mt-6 relative h-fit">
            <div className="ml-7 lg:ml-12 flex flex-col gap-4">
              {Array.from({ length: 2 }).map((_, categoryIndex) => (
                <div key={categoryIndex} className="mb-4">
                  <div className="absolute left-1 w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
                  <div className="relative w-full md:w-[29.6875rem]">
                    <div className="h-10 bg-gray-200 rounded-lg w-full"></div>
                  </div>

                  <div className="my-4 relative h-fit pb-6">
                    <div className="h-5 bg-gray-200 rounded w-24"></div>
                    <div className="relative h-fit mt-2">
                      <div className="ml-6 flex flex-col gap-4">
                        {Array.from({ length: 2 }).map((_, skillIndex) => (
                          <div
                            key={skillIndex}
                            className="flex flex-col gap-2 mb-4"
                          >
                            <div className="absolute left-1 w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
                            <div className="relative w-full md:w-[29.6875rem]">
                              <div className="h-10 bg-gray-200 rounded-lg w-full"></div>
                            </div>
                            <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
                          </div>
                        ))}
                        <div className="h-5 bg-gray-200 rounded w-32"></div>
                      </div>
                      <div className="absolute left-[0.625rem] top-0 w-[0.125rem] h-full bg-gray-200 bg-opacity-50" />
                      <div className="absolute left-1 bottom-[0.125rem] w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
                    </div>
                  </div>
                </div>
              ))}
              <div className="h-5 bg-gray-200 rounded w-32"></div>
            </div>
            <div className="absolute left-[0.625rem] top-0 w-[0.125rem] h-full bg-gray-200 bg-opacity-50" />
            <div className="absolute left-1 bottom-[0.125rem] w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
          </div>

          {/* Serving Area Section Heading Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
            <div className="h-6 bg-gray-400 rounded w-40"></div>
          </div>

          {/* Serving Area Section Skeleton */}
          <div className="mt-6 relative h-fit">
            <div className="absolute left-1 w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
            <div className="ml-7 lg:ml-12 flex flex-col gap-4">
              {Array.from({ length: 1 }).map((_, cityIndex) => (
                <div key={cityIndex} className="mb-4">
                  <div className="flex flex-wrap gap-[1.0625rem] relative">
                    <div>
                      <div className="h-5 bg-gray-200 rounded w-32 mb-1"></div>
                      <div className="h-12 bg-gray-200 rounded-lg w-full lg:w-[33.125rem]"></div>
                    </div>
                    <div>
                      <div className="h-5 bg-gray-200 rounded w-32 mb-1"></div>
                      <div className="h-12 bg-gray-200 rounded-lg w-full lg:w-[33.125rem]"></div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="h-5 bg-gray-200 rounded w-32"></div>
            </div>
            <div className="absolute left-1 bottom-0 w-[0.9375rem] h-[0.9375rem] bg-gray-200 rounded-full" />
          </div>

          {/* Payout Details Heading Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
            <div className="h-6 bg-gray-400 rounded w-40"></div>
          </div>

          <div className="mt-6 flex flex-col gap-[0.625rem]">
            {/* Mobile Money Provider Dropdown Skeleton */}
            <div className="flex flex-col gap-2">
              <div className="h-5 bg-gray-200 rounded w-32"></div>
              <div className="h-10 bg-gray-200 rounded-lg w-full md:w-[16.5rem]"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.063rem]">
              {/* Mobile Number Skeleton */}
              <div className="flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>

              {/* Account Holder's Full Name Skeleton */}
              <div className="flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
            </div>
          </div>

          {/* Payout-Bank Details Heading Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
            <div className="h-6 bg-gray-400 rounded w-40"></div>
          </div>

          <div className="mt-6 flex flex-col gap-[0.625rem]">
            {/* Bank Name Dropdown Skeleton */}
            <div className="flex w-full gap-[1.063rem]">
              {/* Bank Name */}
              <div className="flex flex-col gap-2 w-[30%]">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>

              {/* Full Name */}
              <div className="flex flex-col gap-2 flex-1">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-[1.063rem]">
              {/* Account Number Skeleton */}
              <div className="flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>

              {/* Branch Name Skeleton */}
              <div className="flex flex-col gap-2">
                <div className="h-5 bg-gray-200 rounded w-32"></div>
                <div className="h-12 bg-gray-200 rounded-lg w-full"></div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col gap-12">
            <div className="w-full border-[1px] border-gray-200"></div>
            <div className="flex flex-row gap-4 justify-end">
              <div className="h-[46px] w-[120px] bg-gray-200 rounded-xl"></div>
              <div className="h-[46px] w-[120px] bg-gray-200 rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskerEditProfileSkelton;
